import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/mario/google/index.js